<template>
  <div class="outer-wrap">
    <div class="rule-group">
      <div
          v-show="showRows"
          class="left-cond-wrap"
      >
        <div class="v-line up">
          <div class="h-line"></div>
        </div>
        <el-select
            v-model="formData.operationSymbol"
            style="width: 60px"
            size="small"
            placeholder="关系"
        >
          <el-option label="且" value="and"></el-option>
          <el-option label="或" value="or"></el-option>
        </el-select>
        <div class="v-line down">
          <div class="h-line"></div>
        </div>
      </div>
      <div class="right-rule-wrap">
        <template v-for="(item, index) in formData.rows" :key="item.id">
          <div v-show="item.ruletype === 'd'" class="rule-row">
            <div class="rule-row-content">
              <el-select
                  v-if="modelList.length"
                  class="m-2 rule-row-item"
                  v-model="item.modelId"
                  @change="bindModel"
                  :size="styleConfig?.size || 'default'"
              >
                <el-option
                    v-for="item in modelList"
                    :key="item.modelId"
                    :label="item.modelName"
                    :value="item.modelId"
                />
              </el-select>
              <el-select
                  v-if="modelList.length"
                  class="m-2 rule-row-item"
                  v-model="item.fieldMap"
                  value-key="id"
                  :size="styleConfig?.size || 'default'"
              >
                <el-option
                    v-for="item in getModelFields(item.modelId)"
                    :key="item.id"
                    :label="item.fieldName"
                    :value="item"
                />
              </el-select>
              <el-select
                  v-if="selectArr.length"
                  v-model="item.fieldMap"
                  class="m-2 rule-row-item"
                  placeholder="请选择数据"
                  value-key="code"
                  @change="metricsChange(item, $event)"
                  :size="styleConfig?.size || 'default'"
              >
                <el-option
                    v-for="item in selectArr"
                    :key="item.code"
                    :label="item.name"
                    :value="item"
                >
                  <div class="cs-drag-item move bg ellipsis">
                    <svg-icon
                        color="#878f95"
                        class="text m mr-4"
                        :icon-class="getIcon(item.fieldType)"
                    />
                    <span>{{ item.name }}</span>
                  </div>
                </el-option>
              </el-select>
              <el-select
                  v-model="item.oper"
                  class="m-2 rule-row-item"
                  placeholder="请选择操作符"
                  @change="operatorChange(index)"
                  :size="styleConfig?.size || 'default'"
              >
                <template v-for="op in operatorsList" :key="op.value">
                  <el-option
                      v-if="showOp(op,item)"
                      :label="op.label"
                      :value="op.key"
                  />
                </template>
              </el-select>
              <el-select
                  v-if="showNumType(item)"
                  v-model="item.valueType"
                  class="m-2 rule-row-item"
                  placeholder="选择数值类型"
                  :size="styleConfig?.size || 'default'"
              >
                <el-option
                    v-for="opt in item.fieldMap.fieldType == 'Date' ? valueTypeOpt: valueTypeOpt.filter(v=> v.value !=='fixedDate')"
                    :key="opt.value"
                    :label="opt.name"
                    :value="opt.value"
                />
              </el-select>

              <BindModel
                  :linkData="linkData"
                  v-if="item.valueType == 'pageEntry'"
                  v-model="item.bindKey"
                  v-model:bindParam="item.bindParam"
                  showPageParam
                  show-loop
              ></BindModel>
              <!-- 日期精度选择 -->
              <el-select
                  v-if="showDateType(item)"
                  v-model="item.funcType"
                  clearable
                  class="m-2 rule-row-item"
                  placeholder="请选择日期类型"
                  :size="styleConfig?.size || 'default'"
              >
                <template v-for="opt in dateAccuracyType" :key="opt.value">
                  <el-option
                      v-if="opt.fieldHideArr ? !opt.fieldHideArr.includes(item.oper) : true"
                      :label="opt.label"
                      :value="opt.value"
                  />
                </template>
              </el-select>
              <el-select
                  v-model="item.fixedValue"
                  placeholder="固定日期标识"
                  v-if="showFixDateType(item)"
                  class="rule-row-item m-2"
                  :size="styleConfig?.size || 'default'"
              >
                <el-option
                    v-for="da in dateTimeTypeArr"
                    :label="da.label"
                    :value="da.value"
                    :key="da.value"
                ></el-option>
              </el-select>
              <template v-else>
                <el-input-number
                    v-if="showInputNum(item)"
                    v-model="item.timeOffset"
                    class="rule-row-item m-2"
                    :size="styleConfig?.size || 'default'"
                />
                <template v-if="!['is null', 'is not null'].includes(item.oper)">
                  <!-- 普通文本 -->
                  <template
                      v-if="showInput(item)"
                  >
                    <el-input
                        v-if="showInputFixed(item)"
                        v-model="item.fixedValue"
                        class="m-2 rule-row-item"
                        placeholder="请输入固定值"
                        :size="styleConfig?.size || 'default'"
                    ></el-input>
                    <el-select
                        v-if="['Ref', 'Dict'].includes(item.fieldMap.fieldType)"
                        v-model="item.fixedValue"
                        filterable
                        :multiple="
                        ['in', 'not in'].includes(item.oper) ? true : false
                      "
                        :reserve-keyword="false"
                        placeholder="选择固定值"
                        @focus="getRefList(item)"
                        class="m-2 rule-row-item"
                        :size="styleConfig?.size || 'default'"
                    >
                      <el-option
                          v-for="item in item.refList"
                          :key="item.value"
                          :label="item.label"
                          :value="item.value"
                      />
                    </el-select>
                    <el-select
                        v-if="indexCard"
                        v-model="item.fixedValue"
                        filterable
                        allow-create
                        :reserve-keyword="false"
                        placeholder="输入或选择固定值"
                        @focus="getDimentionList(item)"
                        class="m-2 rule-row-item"
                        :size="styleConfig?.size || 'default'"
                    >
                      <el-option
                          v-for="item in item.dmList"
                          :key="item.code"
                          :label="item.name"
                          :value="item.code"
                      />
                    </el-select>
                  </template>
                  <!-- 自定义下拉选项 -->
                  <el-select
                      v-model="item.filterValueList"
                      v-if="showCusSelect(item)"
                      multiple
                      filterable
                      allow-create
                      default-first-option
                      :reserve-keyword="false"
                      placeholder="请输入固定值"
                      class="m-2 rule-row-item"
                      :size="styleConfig?.size || 'default'"
                  >
                    <el-option
                        v-for="item in options"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                    />
                  </el-select>
                  <!-- 数字框支持小数 -->
                  <el-input-number
                      v-if="showDigits(item)"
                      class="flex-shrink m-2 rule-row-item"
                      v-model="item.fixedValue"
                      @change="handleChange"
                      :size="styleConfig?.size || 'default'"
                  />
                  <!-- 数字范围 -->
                  <div
                      class="number-range rule-row-item m-2"
                      v-if="showDigitsRange(item)"
                  >
                    <el-input-number
                        v-model="item.filterValueList[0]"
                        @change="handleChange"
                        :size="styleConfig?.size || 'default'"
                    />
                    ~
                    <el-input-number
                        v-model="item.filterValueList[1]"
                        placeholder=""
                        :size="styleConfig?.size || 'default'"
                    />
                  </div>
                  <!-- 时间标识组件 -->
                  <!-- <el-select
                    v-model="item.fixedValue"
                    placeholder="固定日期标识"
                    v-if="
                      item.fieldMap &&
                      item.fieldMap.fieldType == 'Date' &&
                      (item.oper == 'period' || item.oper == '[a,b]' || item.oper == '=') &&
                      item.valueType == 'fixedValue'
                    "
                    class="rule-row-item m-2"
                  >
                    <el-option
                      v-for="da in dateTimeTypeArr"
                      :label="da.label"
                      :value="da.value"
                      :key="da.value"
                    ></el-option>
                  </el-select> -->
                  <!-- 日期时间选择组件 -->
                  <el-date-picker
                      v-model="item.fixedValue"
                      :type="dateFormatMap[item.funcType]?.type"
                      :format="dateFormatMap[item.funcType]?.format"
                      :value-format="dateFormatMap[item.funcType]?.format"
                      placeholder="选择日期"
                      v-if="showDate(item)"
                      class="rule-row-item m-2"
                      :size="styleConfig?.size || 'default'"
                  />
                  <!--布尔值 -->
                  <el-select
                      v-model="item.fixedValue"
                      placeholder="固定值"
                      v-if="showBoolean(item)"
                      class="rule-row-item m-2"
                      :size="styleConfig?.size || 'default'"
                  >
                    <el-option label="true" :value="true"></el-option>
                    <el-option label="false" :value="false"></el-option>
                  </el-select>
                </template>
              </template>
            </div>
            <!-- <slot name="condition" :data="item" :index="index"></slot> -->
            <!-- <el-button size="small" style="margin-left: 10px" @click="handleAddClick"
							>添加</el-button
						> -->
            <div class="btns">
              <el-icon
                  class="ml-4 pointer hover"
                  @click="handleAddClick"
                  title="添加项"
              >
                <CirclePlus/>
              </el-icon>
              <el-icon
                  class="ml-4 pointer hover"
                  @click="handleAddChildClick(item, index)"
                  title="添加子项"
              >
                <DocumentAdd/>
              </el-icon>
              <el-icon
                  class="ml-4 pointer hover"
                  @click="handleRemoveClick(index)"
                  title="删除"
                  v-if="formData.rows.length > 1"
              >
                <Delete/>
              </el-icon>
              <el-icon
                  class="ml-4 pointer hover"
                  @click="handleCleanClick(index)"
                  title="清空"
              >
                <CircleClose/>
              </el-icon>
            </div>
          </div>
          <zk-bc-rule-group
              v-if="item.ruletype !== 'd'"
              :data="item"
              :selectArr="selectArr"
              :level="props.level + 1"
              :modelList="props.modelList"
              :linkData="linkData"
              @up="handleLevelUp(index, $event)"
          ></zk-bc-rule-group>
        </template>
      </div>
    </div>
  </div>
</template>

<script setup>
import {computed, ref} from "vue";
import {ElMessage} from "element-plus";
import {
  valueTypeOpt,
  operators,
  dateTimeTypeArr,
  dateAccuracyType,
  dateFormatMap,
} from "@/option/common/dict.js";
import {MODEL_COLUMN_TYPE} from "@/option/common/dict.js";
import BindModel from "./bindModel.vue";
import {dataCenterDao, ruleDataDao} from "@/option/common/dao.js";
import {
  CirclePlus,
  DocumentAdd,
  Delete,
  CircleClose,
} from "@element-plus/icons-vue";

defineOptions({
  name: "zk-bc-rule-group",
});
const props = defineProps({
  linkData: {
    type: Object,
  },
  data: {
    type: Object,
  },
  formDef: {
    type: Object,
    default: function () {
      return {};
    },
  },
  selectArr: {
    type: Array,
    default: function () {
      return [];
    },
  },
  unsupportedOperators: {
    type: Array,
    default: function () {
      return [];
    },
  },
  modelList: {
    type: Array,
    default: function () {
      return [];
    },
  },
  // isPageVar: {
  //   type: Boolean,
  //   default: function () {
  //     return false;
  //   },
  // },
  level: {
    type: Number,
    default: 1,
  },
  // 是否是指标卡配置 指标卡有特殊选择
  indexCard: {
    type: Boolean,
    default: false,
  },
  // 对应组件的配置
  option: {},
  // 样式配置项
  styleConfig: {},
});
const errorTip = ElMessage.error;
const emit = defineEmits(["up"]);
let model = ref(null);
const formData = computed({
  get() {
    return props.data;
  },
  set(v) {
    console.log(v);
  },
});
const showRows = computed(() => {
  return formData.value.rows && formData.value.rows.length > 1;
})

function showOp(op, item) {
  return item.fieldMap && op.fieldShowArr.includes(item.fieldMap.fieldType)
}

function showNumType(item) {
  return item.oper && !['is null', 'is not null'].includes(item.oper)
}

function showDateType(item) {
  return item.oper && !['is null', 'is not null'].includes(item.oper) && item.fieldMap.fieldType === 'Date'
}

function showFixDateType(item) {
  return item.fieldMap &&
      item.fieldMap.fieldType == 'Date' &&
      (item.oper == 'period' || item.oper == '[a,b]' || item.oper == '=') &&
      item.valueType === 'fixedDate'
}

function showInputNum(item) {
  return item.oper &&
      !['is null', 'is not null'].includes(item.oper) &&
      item.fieldMap.fieldType == 'Date'
}

function showInput(item) {
  return item.fieldMap &&
      ['String', 'string', 'Ref', 'Dict'].includes(
          item.fieldMap.fieldType
      ) &&
      !['in', 'not in'].includes(item.oper) &&
      item.valueType == 'fixedValue'
}

function showInputFixed(item) {
  return !props.indexCard && !['Ref', 'Dict'].includes(item.fieldMap.fieldType)
}

function showCusSelect(item) {
  return item.fieldMap && ['in', 'not in'].includes(item.oper) && ['String', 'string'].includes(item.fieldMap.fieldType) && item.valueType == 'fixedValue'
}

function showDigits(item) {
  return item.fieldMap && ['Number', 'int', 'double'].includes(item.fieldMap.fieldType) && item.oper !== '[a,b]' && item.valueType == 'fixedValue'
}

function showDigitsRange(item) {
  return item.fieldMap &&
      ['Number', 'int', 'double'].includes(
          item.fieldMap.fieldType
      ) &&
      item.oper == '[a,b]' &&
      item.valueType == 'fixedValue'
}

function showDate(item) {
  return item.fieldMap &&
      item.fieldMap.fieldType == 'Date' &&
      item.oper !== 'period' &&
      item.oper !== '[a,b]' &&
      item.valueType == 'fixedValue' &&
      item.funcType
}

function showBoolean(item) {
  return item.fieldMap && item.fieldMap.fieldType == 'Boolean' && item.valueType == 'fixedValue'
}

const operatorsList = computed(() => {
  if (!props?.unsupportedOperators?.length) {
    return operators
  } else {
    // 过滤掉不支持的符号
    return operators.filter(item => !props?.unsupportedOperators?.find(unItem => unItem.key === item.key))
  }
})

function getDimentionList(item) {
  dataCenterDao
      .getDMList({
        modelCode: props.option.prop?.dataCenter?.modelId,
        serviceType: "dataCount",
        bizIdentity: "data_model",
        fieldCode: item?.fieldMap?.code,
      })
      .then((el) => {
        item.dmList = el;
      });
}

function getRefList(item) {
  ruleDataDao
      .getRefData({
        modelId: model?.modelId, // 模型ID
        fieldId: item?.fieldMap?.id, // 字段ID
        appId: item?.fieldMap?.appId, // 应用ID
        version: model?.version, // 应用版本
      })
      .then((el) => {
        item.refList = el;
      });
}

function operatorChange(index) {
  formData.value.rows[index].fixedValue = "";
  formData.value.rows[index].filterValueList = [];
  formData.value.rows[index].valueType = "";
}

function getIcon(type) {
  switch (type) {
    case MODEL_COLUMN_TYPE.date:
      return "date";
    case MODEL_COLUMN_TYPE.number:
      return "123";
    default:
      return "abc";
  }
}

function bindModel(modelId) {
  props.modelList.map((item) => {
    if (item.modelId == modelId) {
      model = item;
    }
  });
  console.log(model);
}

function createNewNodeData() {
  let obj = {
    ruletype: "d",
    id: getUUID(),
    operationSymbol: "and",
  };
  Object.assign(obj, props.formDef);
  return obj;
}

function handleAddChildClick(data, index) {
  if (formData.value.rows.length == 1) {
    handleAddClick();
    return;
  }
  // 改变父元素的类型
  formData.value.rows[index] = {
    id: getUUID(),
    ruletype: "c",
    operationSymbol: "and",
    rows: [JSON.parse(JSON.stringify(data)), createNewNodeData()],
  };
}

function handleAddClick() {
  formData.value.rows.push(createNewNodeData());
}

function handleRemoveClick(index) {
  // 增加删除判断,最后一个不可以删除
  if (props.level == 1 && formData.value.rows.length == 1) {
    errorTip("根节点不可以删除");
    return;
  }
  formData.value.rows.splice(index, 1);
  if (formData.value.rows.length == 1) {
    let obj = formData.value.rows[0];
    emit("up", obj);
  }
}

function handleCleanClick(index) {
  formData.value.rows[index] = {
    ruletype: formData.value.rows[index].ruletype,
    id: getUUID(),
    operationSymbol: "and",
  };
}

function handleLevelUp(index, obj) {
  formData.value.rows[index] = obj;
}

function getModelFields(modelId) {
  model = props.modelList.find((m) => m.modelId == modelId);
  if (model) {
    return model.businessModelFieldsDtoList;
  }
  return [];
}

let index = 1;

function getUUID() {
  return new Date().getTime() + "-" + index++;
}

function metricsChange(item, v) {
  item.fixedValue = "";
  item.timeOffset = "";
  item.funcType = "";
}

function changeToFormData(fp, keyCode) {
  let newFp = {
    operationSymbol: fp.operationSymbol,
    children: [],
  };
  newFp[keyCode] = [];
  fp.rows.forEach((child) => {
    child.type = child?.fieldMap?.type || "";
    child.code = child?.fieldMap?.code || "";
    child.fieldType = child?.fieldMap?.fieldType || "";
    child.fixedValue = String(child?.fixedValue);
    if (child.valueType == "pageEntry") {
      child.fixedValue = "";
    }
    if (child.ruletype == "d") {
      let nb = JSON.parse(JSON.stringify(child));
      delete nb.ruletype;
      delete nb.id;
      newFp[keyCode].push(nb);
    } else {
      newFp.children.push(changeToFormData(child, keyCode));
    }
  });
  return newFp;
}

function changeToComponentData(fp, keyCode) {
  let newFp = {
    id: fp.id || getUUID(),
    operationSymbol: fp.operationSymbol,
    rows: [],
  };
  fp[keyCode].forEach((gf) => {
    let nb = JSON.parse(JSON.stringify(gf));
    nb.ruletype = "d";
    newFp.rows.push(nb);
  });
  fp.children.forEach((child) => {
    let nb = JSON.parse(JSON.stringify(child));
    nb.ruletype = "c";
    newFp.rows.push(changeToComponentData(nb, keyCode));
  });

  return newFp;
}

defineExpose({
  changeToFormData,
  changeToComponentData,
});
</script>

<style lang="scss" scoped>
.flex-shrink {
  flex-shrink: 0;
}

.number-range {
  display: flex;
  align-items: center;
}

.outer-wrap {
  overflow: auto;
  //background-color: #fff;
  display: inline-block;
  min-width: 100%;
  margin-bottom: 10px;
}

.rule-group {
  display: flex;
  padding-top: 10px;

  .left-cond-wrap {
    display: flex;
    flex-direction: column;
    align-items: center;
    margin: 0 10px;

    .v-line {
      flex: 1;
      width: 2px;
      background-color: #aaa;
      position: relative;

      &.up {
        margin-top: 10px;

        .h-line {
          top: 0;
        }
      }

      &.down {
        margin-bottom: 20px;

        .h-line {
          bottom: 0;
        }
      }

      .h-line {
        position: absolute;
        width: 30px;
        height: 2px;
        background-color: #aaa;
        left: 0;
      }
    }
  }

  .rule-row {
    display: flex;
    margin-bottom: 10px;
    padding-right: 10px;

    .rule-row-content {
      display: flex;
      align-items: center;
      flex-wrap: wrap;

      .rule-row-item {
        width: 140px;
      }
    }

    .btns {
      display: flex;
      align-items: center;
    }

    .rule-input-wrap {
      flex-shrink: 0;
      flex-grow: 0;
      width: 150px;
      margin-right: 10px;
    }
  }
}

.hover:hover {
  color: #409eff;
}
</style>
